import React from "react";
import { ModuleConfig } from "../../types/ModuleConfig";

// Import components (lazy-loaded for performance)
const BdayGuestList = React.lazy(() => import("./BdayGuestList"));
const BdayGuestForm = React.lazy(() => import("./BdayGuestForm"));

const bdayModuleConfig: ModuleConfig = {
    // MODULE IDENTITY
    id: "bday",
    name: "Birthday RSVP",
    description: "Manage guest list and RSVPs for Tom's 40th Birthday",
    version: "1.0.0",
    enabled: true,
    category: "events",
    order: 50,
    icon: "🎂",
    color: "#D4AF37",

    // ROUTES
    routes: [
        {
            path: "/bday/admin",
            component: BdayGuestList,
            permissions: ["ADMIN"],
            useLayout: true,
        },
        {
            path: "/bday/admin/guests",
            component: BdayGuestList,
            permissions: ["ADMIN"],
            useLayout: true,
        },
        {
            path: "/bday/admin/guests/new",
            component: BdayGuestForm,
            permissions: ["ADMIN"],
            useLayout: true,
        },
        {
            path: "/bday/admin/guests/:id/edit",
            component: BdayGuestForm,
            permissions: ["ADMIN"],
            useLayout: true,
        }
    ],

    // NAVIGATION
    navigation: [
        {
            label: "Guest List",
            path: "/bday/admin/guests",
            icon: "👥",
            permissions: ["ADMIN"]
        },
        {
            label: "Add Guest",
            path: "/bday/admin/guests/new",
            icon: "➕",
            permissions: ["ADMIN"]
        }
    ],

    // PERMISSIONS
    permissions: {
        view: ["ADMIN"],
        create: ["ADMIN"],
        edit: ["ADMIN"],
        delete: ["ADMIN"]
    },

    // QUICK ACTIONS
    quickActions: [
        {
            label: "View Guests",
            path: "/bday/admin/guests",
            icon: "👥",
            description: "View all guests and RSVP status"
        },
        {
            label: "Add Guest",
            path: "/bday/admin/guests/new",
            icon: "➕",
            description: "Add a new guest to the list"
        }
    ],

    // CHANGELOG
    changelog: [
        {
            version: "1.0.0",
            releaseDate: "2026-01-10",
            title: "Initial Release - Birthday RSVP",
            features: [
                "Guest management with custom URL slugs",
                "RSVP tracking (Attending, Not Attending, Maybe)",
                "Plus ones tracking",
                "Personalized invite pages",
                "RSVP statistics dashboard"
            ],
            notes: "First release of the Birthday RSVP module for Tom's 40th."
        }
    ],

    // ROADMAP
    roadmap: []
};

export default bdayModuleConfig;
